import { render, staticRenderFns } from "./KFixedGrid.vue?vue&type=template&id=27ff5136&"
import script from "./KFixedGrid.vue?vue&type=script&lang=js&"
export * from "./KFixedGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports